import { Flex, freddyTheme, SpriteIcon, Typography } from '@coolblue-development/freddy';
import { ProductType } from '@features/product/components/Collection/Collection.types';
import { CollectionTitle } from '@features/product/components/Collection/Shared';
import useTestId from '@hooks/useTestId';
import { Fragment, ReactNode } from 'react';

type MobileEntranceProps = {
  handleOpenModal: () => void;
  collectionTitle: string;
  productType?: ProductType | null;
  currentValues: string[];
  valueSeparator: string;
  showTitleInline?: boolean;
};

export const MobileEntrance = ({
  handleOpenModal,
  collectionTitle,
  productType,
  currentValues,
  valueSeparator,
  showTitleInline = true
}: MobileEntranceProps): ReactNode => {
  const testId = useTestId('mobile-entrance');

  return (
    <Flex
      {...testId}
      onClick={handleOpenModal}
      justifyContent='space-between'
      alignItems='center'
      p={300}
      sx={{
        border: `${freddyTheme.borderWidth[25]} solid ${freddyTheme.color.border.interactiveBase}`,
        borderRadius: freddyTheme.borderRadius[100]
      }}
    >
      <Flex gap={100} sx={{ overflow: 'hidden' }}>
        {showTitleInline && (
          <CollectionTitle title={collectionTitle} productType={productType} variant='entrance' />
        )}
        {currentValues.map((currentValue, index) => {
          const totalValues = currentValues.length;

          return (
            currentValue && (
              <Fragment key={index}>
                <Typography
                  m={0}
                  sx={{
                    whiteSpace: 'nowrap',
                    ...(index === totalValues - 1 && {
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    })
                  }}
                >
                  {currentValue}
                </Typography>
                {index < totalValues - 1 && (
                  <Typography m={0} color='additional'>
                    {valueSeparator}
                  </Typography>
                )}
              </Fragment>
            )
          );
        })}
      </Flex>
      <SpriteIcon name='arrow-right' color={freddyTheme.color.icon.interactiveDisabled} />
    </Flex>
  );
};
